import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/custom-software/client.webp";

function Banner(props) {
  return (
    <div className="experienced p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Client-Centric Approach to Add Genuine Value to Your Business
            </h2>
            <p>
              At TekRevol, our commitment to custom software development is
              rooted in a client-centric approach aimed at bringing genuine
              value to your business. We believe in simplicity and effectiveness
              to ensure that our solutions align perfectly with your needs.
            </p>
            <p>
              Our process starts with comprehensively understanding your
              business. We listen to your requirements and challenges, tailoring
              our development approach to meet your specific needs. Your
              insights form the foundation for building the customized software
              solutions your business needs.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let's Take Your Brand Online
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
